import gql from 'graphql-tag';
import { shipmentListFragment } from '../../../../../../graphql/query/shipmentList';

export default gql`
  query LazadaShipmentListDetail($_id: ID) {
    shipmentList(_id: $_id, shipment_prefix: "GJD") {
      shipment {
        ...shipmentFields
      }

      total_page
    }
  }

  ${shipmentListFragment}
`;
